<img [src]="'assets/img/'+src" [ngClass]="class" [style.width.px]="size" /> 


